/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

import React, { Component } from "react";
import "./styles/css/terms-of-service.css";
import { Button, Segment, Form, Input, Header, Checkbox, Dimmer, Loader } from "semantic-ui-react";
import { Link, Redirect } from "react-router-dom";
import Images from "../media/tos/tos";
import API from "../utility/API";
import moment from "moment";
import TOS from "./tos";
import EmailImage from "../Images/email-32.svg";
import { get } from "lodash";

class TermsOfService extends Component {
  constructor() {
    super();
    this.state = {
      accept: false,
      toNextPage: false,
      tempToken: "",
      date: moment().format("MMMM Do YYYY"),
      isLoading: false,
      tokenValidation: false,
      mailSent: false,
      message: "",
      errorMessage: false,
    };
  }

  componentWillMount() {
    const pathArray = window.location.pathname.split("/");
    const tempToken = pathArray[4];
    // console.log("The user's tempory token is", tempToken);
    console.log(typeof tempToken);
    this.setState({ tempToken: tempToken, isLoading: true }, () => console.log(this.state));
    this.validateTempToken(tempToken);
  }

  validateTempToken = (tempToken) => {
    if (tempToken)
      API.authenticateToken(tempToken).then(response => { return response.json(); })
        .then(res => {
          if(res.errorCode != 200){
            this.setState({tokenValidation: false, isLoading: false})
          }else{
            this.setState({ tokenValidation: true, isLoading: false})
          }
        }).catch(err => {
          this.setState({ isLoading: false})
          console.error("ERROR:", err);
        })
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value }, () => console.log(this.state));

  toggle = () => this.setState({ accept: !this.state.accept }, console.log(this.state.accept));

  onSubmit = () => {
    // const { accept } = this.state
    this.setState({ isLoading: true })
    // 	console.log(this.state))
    if(this.state.tokenValidation){
      API.termsOfService(this.state.tempToken)
      .then((response) => {
        return response.json();
      })
      .then((responseData) => {
        this.props.storeSessionData(responseData.eventMessage.userBasicInfo.companyName, responseData.eventMessage.userBasicInfo.email, responseData.eventMessage.userBasicInfo.contactName, this.state.tempToken);
      })
      .then(() =>
        this.setState(() => ({
          isLoading: false,
          toNextPage: true
        }))
      )
      .catch((err) => console.log("ERROR:", err));
    }else{
      API.resendVerificationLink(this.state.tempToken).then(res => { return res.json() })
        .then(res => {
          // console.log("checking res", res);
          this.setState({ isLoading: false });
          if (res.eventMessage.header.code === 200) {
            this.setState({ mailSent: true, message: "A link has been sent to your mail box. Please check and complete your registration." });
          }else{
            this.setState({errorMessage: true, message: "Unable to send mail."})
          }
        }).catch(err => {
          this.setState({ isLoading: false });
          console.error("CHECK ERROR: ", err);
        })
    }
    
  };

  render() {
    if (this.state.toNextPage === true) {
      return <Redirect to="/basicinfo" />;
    }

    const { isLoading, tokenValidation, mailSent, message, errorMessage } = this.state;

    return (
      <Segment padded="very" className="tos-form">
        {isLoading && (
          <Dimmer active inverted>
            <Loader size="medium">Loading</Loader>
          </Dimmer>
        )}
        <Form onSubmit={this.handleSubmit}>
          {tokenValidation ?
            <React.Fragment>
              <center>
                <Header className="tos-title" as="h1">
                  KLEARNOW Corp. Terms and conditions of service.
                </Header>
                <Header className="tos-title" as="h5">
                  UNITED STATES AND CANADA
                </Header>
                <Header className="tos-title" as="h5">
                  As of October 5th, 2018
                </Header>
              </center>
              <Form.Field>
                <div className="tosContainer">
                  <TOS />
                </div>
              </Form.Field>
              <div>
                <Checkbox className="tosAccept" label="I ACCEPT THE TERMS AND CONDITIONS." value="accept" name="checkbox-accept-tos" checked={this.state.accept} onClick={this.toggle} />
                <br /><br />
                <center>

                  {/* <Link to='/basicinfo'> */}
                  <Button disabled={this.state.accept === false} onClick={this.onSubmit.bind(this)} type="submit" className="tosSubmit">
                    GET STARTED
                  </Button>
                </center>
              </div>
            </React.Fragment> :
            !isLoading &&
            <React.Fragment>
              <center>
                <img src={EmailImage} className="email-image" alt="email-image" />
                <Header className="tos-title" as="h1">
                  Email verification link expired
                </Header>
                <p className="tos-title">
                  Looks like the verification link has expired. Not to worry, we can send the link again.
                </p>
                {
                  mailSent && <h4 style={{color: "green"}}>{message}</h4>
                }
                {
                  errorMessage && <h4 style={{color: "red"}}>{message}</h4>
                }
              </center>
              {/* --------- Resend verification link button ---------- */}
              <center className="resend-button">
                <Button disabled={mailSent} onClick={this.onSubmit.bind(this)} type="submit" className="tosSubmit">
                  RESEND VERIFCATION LINK
                </Button>
              </center>
            </React.Fragment>
          }
          {/* </Link> */}
        </Form>
      </Segment>
    );
  }
}

export default TermsOfService;
